import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

type UseFilterField = [string | null, (value: string) => void];

export function useFilter(name: string): UseFilterField {
  const [params, setParams] = useSearchParams();

  const setValue = useCallback(
    (value: string) => {
      if (value === '') {
        params.delete(name);
      } else {
        params.set(name, value);
      }

      setParams(params);
    },
    [name, params, setParams]
  );

  return [params.get(name), setValue];
}
